module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place column"
  }, [_c('div', {
    staticClass: "take-place from-start column"
  }, [_c('div', {
    staticClass: "heading-sub-client-container"
  }, [_c('div', {
    staticClass: "heading-sub-client row start"
  }, [_c('router-link', {
    staticClass: "btn-icon",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.clientId
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Détails de la situation de "), (_vm.client) ? _c('span', [_vm._v(_vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.investmentStats) ? _c('synthesis', {
    attrs: {
      "investment-stats": _vm.investmentStats
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bee58374"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Contacts/Investments.vue
// module id = 1168
// module chunks = 0